import { ObjectResponseType } from '@pray/shared/utils/api/types/response';

import { RegenerateEpisodeResponse } from './types';

export type RegenerateEpisodeServiceParams = {
  artistId: string;
  courseId: string;
  episodeId: string;
};

/**
 * Regenerates content for a course episode using AI
 * @param params - The parameters for the regenerate episode request
 * @param params.episodeId - The ID of the episode to regenerate
 * @returns A promise that resolves to the regenerate episode response data
 */
export async function regenerateEpisode({ artistId, courseId, episodeId }: RegenerateEpisodeServiceParams) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!courseId) throw new Error('Course ID is required');
  if (!episodeId) throw new Error('Episode ID is required');

  await new Promise((resolve) => setTimeout(resolve, 1000));

  const response: RegenerateEpisodeResponse = {
    /* eslint-disable camelcase */
    responded_at: new Date().toISOString(),
    object: ObjectResponseType.OBJECT,
    data: {
      id: episodeId,
      course_id: courseId,
      title: 'New Regenerated Episode Title',
      transcript: '<h1>New Regenerated Episode Title</h1><p>New Regenerated Episode Transcript</p>',
    },
    /* eslint-enable camelcase */
  };

  return response;

  // Uncomment when server implementation is ready
  // const url = `/studio/courses/${courseId}/episodes/${episodeId}/regenerate`;
  // const response = await api.executePutRequest<RegenerateEpisodeResponse>(url);
  // return response.data;
}
